exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  box-sizing: border-box;\n}\n\nhtml {\n  /* For rem */\n  font-size: 12px;\n}\n\nbody {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  color: #333;\n}\n\nhtml,\ndiv#root,\nbody,\nmain#location-layout {\n  height: 100%;\n}\n\na {\n  color: #3195ce;\n  text-decoration: none;\n}\n\na:hover, a:active {\n  color: #02659e;\n}\n\ninput[type=password]::-ms-reveal,\ninput[type=password]::-ms-clear {\n  display: none;\n}", ""]);

// exports
